import script from "./KeysReturn.vue?vue&type=script&lang=ts&setup=true"
export * from "./KeysReturn.vue?vue&type=script&lang=ts&setup=true"

import "./KeysReturn.vue?vue&type=style&index=0&id=bd8065d6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd8065d6"]])

export default __exports__